/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInvoicesResult } from '../../models/get-invoices-result';
import { InvoiceStatus } from '../../models/invoice-status';
import { PaymentStatus } from '../../models/payment-status';

export interface ApiBillingInvoicesGet$Params {
  statuses?: Array<InvoiceStatus>;
  paymentStatuses?: Array<PaymentStatus>;
  paymentOverdue?: boolean;
  page?: number;
  perPage?: number;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiBillingInvoicesGet(http: HttpClient, rootUrl: string, params?: ApiBillingInvoicesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvoicesResult>> {
  const rb = new RequestBuilder(rootUrl, apiBillingInvoicesGet.PATH, 'get');
  if (params) {
    rb.query('statuses', params.statuses, {});
    rb.query('paymentStatuses', params.paymentStatuses, {});
    rb.query('paymentOverdue', params.paymentOverdue, {});
    rb.query('page', params.page, {});
    rb.query('perPage', params.perPage, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInvoicesResult>;
    })
  );
}

apiBillingInvoicesGet.PATH = '/api/Billing/invoices';
